import { callService } from '@api/remote-call';
import { SECRET_KEY, SSO_MAIL_KEY, SSO_USER_DATA } from '@constants/constants';
import { TokenViewModel } from '@api/v3';

import { DEFAULT_FAVORITE_LIST_NAME } from '../my-favorites/MyFavoriteComponent/utils';
import {
  REFRESH_TOKEN_KEY,
  TOKEN_EXPIRATION_KEY,
  TOKEN_KEY,
} from './constants';

const SETUR_EMAILS = [
  'setair.com.tr',
  'setur.com.tr',
  'seturbiz.com',
  'kisiyeozelsetur.com.tr',
  'seturday.com',
];
export const isSeturEmail = (email?: string) => {
  return (
    SETUR_EMAILS.indexOf(email?.toString()?.split('@')?.[1] as string) > -1
  );
};

export const reverseDateString = (str: string) => {
  return new Date(str.split('/').reverse().join('-'));
};

export const getCredentialsFromLocalStorageSso = () => {
  try {
    return localStorage.getItem(SSO_MAIL_KEY);
  } catch (error) {
    return null;
  }
};

export const getSSOCredentialsFromLocalStorage = () => {
  try {
    return JSON.parse(localStorage.getItem(SSO_USER_DATA));
  } catch (error) {
    return null;
  }
};

export const getCredentialsFromLocalStorage = () => {
  try {
    return JSON.parse(localStorage.getItem(SECRET_KEY));
  } catch (error) {
    return null;
  }
};

export const handleUpdateUserBasketIdLogin = async (basketId, token) => {
  try {
    if (basketId) {
      const basketData = await callService(
        {
          service: 'BasketsService',
          method: 'getBasket',
          version: 'v3',
        },
        { basketId }
      );
      if (basketData?.isLocked) {
        await callService(
          { service: 'BasketsService', method: 'unlock', version: 'v3' },
          {
            basketId,
          }
        );
        await callService(
          {
            service: 'BasketsService',
            method: 'updateBasketUserId',
            version: 'v3',
          },
          { basketId, authorization: token }
        );
      } else {
        await callService(
          {
            service: 'BasketsService',
            method: 'updateBasketUserId',
            version: 'v3',
          },
          { basketId, authorization: token }
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const handleCreateDefaultWishList = async (token) => {
  try {
    const wishLists = await callService(
      {
        service: 'WishListsService',
        method: 'getWishLists',
        version: 'v3',
      },
      { authorization: token }
    );
    if (
      !wishLists.find(
        (item) =>
          item.name?.toLowerCase() === DEFAULT_FAVORITE_LIST_NAME.toLowerCase()
      )
    ) {
      try {
        await callService(
          {
            service: 'WishListsService',
            method: 'createWishList',
            version: 'v3',
          },
          { body: { name: DEFAULT_FAVORITE_LIST_NAME }, authorization: token }
        );
      } catch (error) {
        console.log(error);
      }
    }
  } catch (error) {
    try {
      await callService(
        {
          service: 'WishListsService',
          method: 'createWishList',
          version: 'v3',
        },
        { body: { name: DEFAULT_FAVORITE_LIST_NAME }, authorization: token }
      );
    } catch (error) {
      console.log(error);
    }
  }
};

export const getExpirationDate = (expiresInSeconds: number) => {
  return new Date(new Date().getTime() + expiresInSeconds * 1000);
};

export const prepareToken = (tokenType: string, token: string) => {
  return `${tokenType} ${token}`;
};

export const saveTokenInfo = async (data: TokenViewModel) => {
  const token = prepareToken(data.tokenType, data.token);
  const tokenExpiration = getExpirationDate(data.expires);

  if (typeof window !== 'undefined') {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TOKEN_EXPIRATION_KEY, tokenExpiration.toISOString());
    localStorage.setItem(REFRESH_TOKEN_KEY, data.refreshToken);
  }
};
